import { makeStyles } from '@material-ui/core';
import { configApiRef, useApi } from '@backstage/core-plugin-api';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 28,
    display: 'block',
  },
});

const LogoIcon = () => {
  const classes = useStyles();
  const configApi = useApi(configApiRef);
  const baseUrl = configApi.getOptionalString('app.baseUrl') ?? '';
  const assetBase = baseUrl.replace(/\/$/, '');
  const logoUrl = `${assetBase}/branding/logo-icon.svg`;

  return <img className={classes.img} src={logoUrl} alt="Arcus" />;
};

export default LogoIcon;
